<div
  class="flex items-center gap-2 relative"
  [style.top.px]="moveIcons ? 172 : null"
  [style.left.px]="moveIcons ? -16 : null">
  <sbnb-icon-airbnb
    *ngIf="hasAirbnbListing"
    [size]="12"
    [muted]="edited"
    [matTooltip]="
      edited
        ? 'This data is not periodically refreshed from Airbnb as it has been manually edited.'
        : 'This data is periodically refreshed from Airbnb.'
    "></sbnb-icon-airbnb>

  <!-- TODO: extract this into an svg icon file -->
  <svg
    matTooltip="This data is pushed to any Direct sites linked to your account."
    width="14"
    height="14"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <rect width="18" height="18" rx="4" fill="#ED3C6A" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.989 11.6926C11.1368 11.6926 12.878 9.97053 12.878 7.84628C12.878 5.72204 11.1368 4 8.989 4C6.84115 4 5.09998 5.72204 5.09998 7.84628C5.09998 9.97053 6.84115 11.6926 8.989 11.6926ZM8.98891 10.1542C10.2776 10.1542 11.3223 9.12097 11.3223 7.84643C11.3223 6.57188 10.2776 5.53866 8.98891 5.53866C7.70021 5.53866 6.6555 6.57188 6.6555 7.84643C6.6555 9.12097 7.70021 10.1542 8.98891 10.1542ZM7.42473 12.4614C6.99988 12.4614 6.65547 12.8058 6.65547 13.2306C6.65547 13.6555 6.99988 13.9999 7.42473 13.9999H10.553C10.9779 13.9999 11.3223 13.6555 11.3223 13.2306C11.3223 12.8058 10.9779 12.4614 10.553 12.4614H7.42473Z"
      fill="white" />
  </svg>
</div>
